import { render, staticRenderFns } from "./Coockies.vue?vue&type=template&id=219e93cb&scoped=true"
import script from "./Coockies.vue?vue&type=script&lang=js"
export * from "./Coockies.vue?vue&type=script&lang=js"
import style0 from "./Coockies.vue?vue&type=style&index=0&id=219e93cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e93cb",
  null
  
)

export default component.exports